import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import AdminMenu from "../AdminMenu";
import AdminHeader from "../AdminHeader";
import axios from "axios";
import ReactPaginate from "react-paginate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd, faCode} from "@fortawesome/free-solid-svg-icons";
import { ADMIN_API_BASE } from "../../../utils/apiConfig";
import ConfirmModal from "../../../components/modal/ConfirmModal";
import convertCourseIdToName from "../../../utils/conversions";
import Button from "../../../components/elements/Button";

const AdminGlossaryList = () => {
    const [filteredGlossaries, setFilteredGlossaries] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [glossaries, setGlossaries] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [glossaryIdToDelete, setGlossaryIdToDelete] = useState(null);
    const itemsPerPage = 10;

    const getCsrfToken = async () => {
        try {
            const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            return data.csrfToken;
        } catch (error) {
            console.error('Error fetching CSRF token:', error);
            return null;
        }
    };

    useEffect(() => {
        const fetchGlossaries = async () => {
            // const token = await getCsrfToken();
            try {
                const response = await axios.get(`${ADMIN_API_BASE}/glossary/:course_id`, {
                    // withCredentials: true,
                    // headers: {
                    //     'csrf-token': token,
                    // },
                });
                setFilteredGlossaries(response.data.data);
            } catch (error) {
                console.error('There was a problem with the axios request:', error);
            }
        };

        fetchGlossaries();
    }, []);

    useEffect(() => {
        let sortedGlossaries = [...glossaries];
        setFilteredGlossaries(sortedGlossaries);
        setCurrentPage(0);
    }, [glossaries]);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const handleDeleteClick = (glossaryId) => {
        setGlossaryIdToDelete(glossaryId);
        setIsModalOpen(true);
    };

    const handleDeleteConfirm = async () => {
        if (!setGlossaryIdToDelete) return;

        try {
            const token = await getCsrfToken();
            await axios.delete(`${ADMIN_API_BASE}/glossary/${glossaryIdToDelete}`, {
                withCredentials: true,
                headers: {
                    'csrf-token': token,
                },
            });
            setGlossaries(glossaries.filter(glossary => glossary.id !== glossaryIdToDelete));
            setFilteredGlossaries(filteredGlossaries.filter(blog => blog.id !== glossaryIdToDelete));
            alert('مقاله با موفقیت حذف شد.');
        } catch (error) {
            console.error('Error deleting blog post:', error);
            alert('خطایی در حذف مقاله رخ داد.');
        } finally {
            setIsModalOpen(false);
            setGlossaryIdToDelete(null);
        }
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setGlossaryIdToDelete(null);
    };

    const offset = currentPage * itemsPerPage;
    const currentGlossaries = filteredGlossaries.slice(offset, offset + itemsPerPage);

    return (
        <>
            <div className="flex flex-1">
                <div className="flex flex-1">
                    <div className='w-1/5'>
                        <AdminMenu path='./'/>
                    </div>
                    <div className='flex-grow w-4/5'>
                        <AdminHeader title={`دیکشنر‌ی`} />
                        <Button className='m-10'>
                            <FontAwesomeIcon icon={faAdd} size="lg" />
                            <span>افزودن</span>
                        </Button>
                        <div className='w-full flex flex-wrap gap-4 py-3 px-10 flex-1 my-10'>
                            {currentGlossaries && currentGlossaries.length > 0 && currentGlossaries.map(glossary => (
                                <div key={glossary.id} className="w-1/5">
                                    <Link to={`/admin/glossary/${glossary.course_id}/${glossary.id}`} className="block">
                                        <div
                                            className="bg-white p-5 shadow-md rounded-sm transition hover:bg-gray-100 hover:-translate-y-2">
                                            <h2 className="text-md line-clamp-2 mb-5">{glossary.title}</h2>
                                        </div>
                                    </Link>
                                    <button
                                        className="bg-red-400 rounded-sm px-3 py-2 mt-2"
                                        onClick={() => handleDeleteClick(glossary.id)}
                                    >
                                        حذف
                                    </button>
                                </div>
                            ))}
                        </div>
                        <ReactPaginate
                            previousLabel={'قبلی'}
                            nextLabel={'بعدی'}
                            breakLabel={'...'}
                            pageCount={Math.ceil(filteredGlossaries.length / itemsPerPage)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination flex justify-center mt-4'}
                            activeClassName={'active'}
                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link p-2 border rounded mx-1'}
                            previousClassName={'page-item'}
                            previousLinkClassName={'page-link p-2 border rounded mx-1'}
                            nextClassName={'page-item'}
                            nextLinkClassName={'page-link p-2 border rounded mx-1'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link p-2 border rounded mx-1'}
                        />
                    </div>
                </div>
            </div>
            <ConfirmModal open={isModalOpen} onConfirm={handleDeleteConfirm} onCancel={handleModalClose} message="آیا مطمئن هستید که می‌خواهید این مقاله را حذف کنید؟"  />
        </>
    );
};

export default AdminGlossaryList;